import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

const graphqlUri = process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/graphql` : '/graphql';

const httpLink = createHttpLink({
  uri: graphqlUri,
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('authToken');
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
});

const profileLink = setContext((_, { headers }) => {
  return { headers };
});

const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.error(`GraphQL error: ${message}`, {
        operation: operation.operationName,
        path,
        locations
      });
    });
  }

  if (networkError) {
    console.error('Network error:', networkError);
    
    // Handle specific network errors
    if (networkError.statusCode === 401) {
      // Token expired, clear auth and redirect
      localStorage.removeItem('authToken');
      window.location.href = '/';
    } else if (networkError.statusCode >= 500) {
      // Server errors - could show user-friendly message
      console.error('Server error - service may be temporarily unavailable');
    } else if (networkError.name === 'NetworkError' && !networkError.statusCode) {
      // Complete network failure (no internet, server down)
      console.error('Network connection failed - check internet connection');
    }
  }
});

const client = new ApolloClient({
  link: errorLink.concat(authLink.concat(profileLink.concat(httpLink))),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          games: {
            keyArgs: [],
            merge(existing = [], incoming, { args }) {
              const offset = args?.offset || 0;
              const merged = existing ? existing.slice() : [];
              
              for (let i = 0; i < incoming.length; ++i) {
                merged[offset + i] = incoming[i];
              }
              
              return merged;
            }
          }
        }
      },
      Game: {
        fields: {
          state: {
            merge(existing, incoming) {
              return incoming;
            }
          }
        }
      }
    }
  })
});

export default client;